// ── TEMPORÄRER TESTZUGANG ───────────────────────────────────────────────────
// True when the logged-in user is the test account from the backend .env
// (no shop session). Shop functions are hidden for this user.
// To revert: delete this file and every usage of isTestUser() / "TEMPORÄRER TESTZUGANG".
export const isTestUser = () => {
  try {
    return JSON.parse(localStorage.getItem("AUTH_DATA") || "{}").testUser === true;
  } catch {
    return false;
  }
};
